module.exports = __webpack_public_path__ + "assets/img/Ultimate-Ears-Landing-page-w960.bb515ae2.webp";